import BaseDataService from "./BaseDataService";
import http from "../http-common";
import httpAuth from "../http-common-auth";

class UserDataService extends BaseDataService {
  constructor(name) {
    super(name)
    this.moduleName = 'registrationdata'
  }

  login(data) {
    return http.post('login', data);
  }

  get() {
    var data = JSON.parse(localStorage.user)['ID']
    if (localStorage['user'] && JSON.parse(localStorage['user'])['Token']) {
      http.defaults.headers['Authorization'] = "Bearer " + JSON.parse(localStorage['user'])['Token']
    }
    return http.get(`registrationdata/${data}`);
  }

  update(data) {
    var id = JSON.parse(localStorage.user)['ID']
    return super.update(id, data)
  }

  updatData(id, data) {
    return super.update(id, data)
  }

  changepassword(data) {
    data['username'] = JSON.parse(localStorage.getItem('user'))['Username']
    return httpAuth.post('changepassword', data);
  }
}

export default new UserDataService();